import { TagGi } from './tag-gi';
import { Signatario } from './signatario';

export class Contato {
  idGIContato: number;
  cnpj: string;
  razao: string;
  fantasia: string;
  nomeContato: string;
  logradouro: string;
  nume: string;
  comp: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
  email: string;
  telefone: string;
  ibge: string;
  idCliente: number;
  vendedor: number;
  nomeVendedor: string;
  cargoContato: string;
  tipo: number;
  site: string;
  dataCadastro: Date;
  possuiAnexos: boolean;
  tags: TagGi[];
  rg?: string;
  inscEst?: string;
  aceitouContrato: boolean;
  signatariosJson: string;
  contatoStatus: number;
  rzkId: string;
  codSuframa: string;
  listaCnaes: string[] | null;
  optanteSimples: boolean | null;
  dataSituacaoSimples: Date | null;
  optanteSimei: boolean | null;
  dataSituacaoSimei: Date | null;
  dataAtualizacaoReceita: Date | null;
  fonteAtualizacaoReceita: string | null;
}
